<h3>Admin</h3>
<form [formGroup]="upsertAdminForm"
  (ngSubmit)="onOkClicked()">
  <mat-form-field>
    <mat-label>Voornaam</mat-label>
    <input matInput
      formControlName="voornaam"
      type="text"
      placeholder="Jan"
      required>
    @if (voornaam.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Achternaam</mat-label>
    <input matInput
      formControlName="achternaam"
      type="text"
      placeholder="Janssen"
      required>
    @if (achternaam.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Personeelsnummer</mat-label>
    <input matInput
      formControlName="personeelsnummer"
      type="text"
      placeholder="P0234"
      required>
    @if (personeelsnummer.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>
  <mat-form-field>
    <mat-label>Email</mat-label>
    <input matInput
      formControlName="email"
      type="email"
      placeholder="jan@janssen.be"
      required>
    @if (email.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
    @if (email.hasError('email')) {
      <mat-error>Geen geldig email adres</mat-error>
    }
  </mat-form-field>
  <div class="actions">
    <button mat-button
      color="primary"
      type="button"
      (click)="onCancelClicked()">
      Annuleer
    </button>
    <button mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!upsertAdminForm.valid">
      {{okLabel}}
    </button>
  </div>
</form>
